import { Injectable } from '@angular/core'
import { NativeDateAdapter } from '@angular/material/core'
import { DATE_FORMATS } from '../../../shared-components/constants'

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: any): string {
    if (displayFormat === DATE_FORMATS.DATE) {
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const day = date.getDate().toString().padStart(2, '0')
      const year = date.getFullYear()
      return `${month}/${day}/${year}`
    }
    return super.format(date, displayFormat)
  }
}
